const tabTypes = {
  FA: "Finite Automaton",
  PDA: "Pushdown Automaton",
  TM: "Turing Machine",
  GR: "Grammer",
  RE: "Regular Expression",

  NFAtoDFA: "NFA to DFA",
  FSAtoRE: "FSA to Regular Expression",
  GRtoPDA: "Grammar to PDA",
  REtoNFA: "Regex to NFA",
  PDAtoGR: "PDA to Grammar",
};

export default tabTypes;
